import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Reducer/authReducer";
import chatReducer from "../Reducer/chatReducer";
import notificationReducer from "../Reducer/notificationReducer"
export const store = configureStore({
    reducer: {
        Auth: authReducer,
        Chat: chatReducer,
        Notification: notificationReducer
    }
})